/*
 * Example usage:
 * const greaterThan10 = gt(10);
 * greaterThan10(11) === true;
 */
export var eq = function (a) { return function (b) { return a === b; }; };
export var gt = function (a) { return function (b) { return b > a; }; };
export var lt = function (a) { return function (b) { return b < a; }; };
export var ge = function (a) { return function (b) { return b >= a; }; };
export var le = function (a) { return function (b) { return b <= a; }; };
//# sourceMappingURL=matchers.js.map